export default __webpack_public_path__ + "static/media/upgrade-cover.1507c2ca.png";